
export const formDataReducerKey = "formData"
export const formDataInitialState = {
   formData:{},
   formDataOf:""
}